// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Size_wrap_1JzE2","input":"Size_input_nFXLo","select":"Size_select__OAfF","selectItem":"Size_selectItem_yzQSb"};